import { NgModule, ErrorHandler } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { APP_ROUTER_PROVIDERS } from "./app.routes";
import { GlobalErrorHandler } from "./global-error-handler";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { IonRangeSliderModule } from "ng2-ion-range-slider";
import {
    MentisSoftSharedModule, GuestAppointmentModule, LoginModule, KioskLoginModule
} from "./appindex";
import { SecurityService, CurrencyDetails, BookingService } from "./appindex";

import { BreadcrumbComponent, FooterComponent, HeaderComponent, NavigationComponent, NavigationService, HeaderService } from "./shared/sharedindex";

import { ApplicationComponent } from "./app.component";

import { Operator } from 'rxjs/Operator';
import { Observable } from 'rxjs/Observable';
declare module 'rxjs/Subject' {
    interface Subject<T> {
        lift<R>(operator: Operator<T, R>): Observable<R>;
    }
}
export function createAppModule(param) {
    @NgModule({
        //import GuestAppointmentModule if onload of application Should redirect to GuestAppointment screen else load only LoginModule
        imports: [BrowserModule, APP_ROUTER_PROVIDERS, FormsModule, HttpModule, LoginModule, KioskLoginModule,IonRangeSliderModule],//GuestAppointmentModule],
        declarations: [ApplicationComponent],
        bootstrap: [ApplicationComponent],
        providers: [BookingService, SecurityService, NavigationService, CurrencyDetails, HeaderService, { provide: ErrorHandler, useClass: GlobalErrorHandler }]
    })
    class AppModule {
        constructor() {
        }
    }
    return AppModule;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/app.module.ts